import Api from '@/services/Api'

export default {
    getUser (params) {
        return Api().get('/users?ldap=' + params)
    }
}